import { normalize } from 'polished'
import { createGlobalStyle, css } from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const styles = css`
  ${normalize()}

  @import url('https://fonts.googleapis.com/css2?family=Catamaran:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@0,400;0,600;1,400&display=swap');

  html,
  body {
    color: ${props => props.theme.palette.general.strong};
    font: ${font('default', 'normal', '16px/1.25rem')};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      font-weight: ${props => props.theme.font.default.light};
    }
  }

  ::selection {
    color: ${props => props.theme.palette.general.light};
    background: ${props => props.theme.palette.general.dark};
  }
`

export const GlobalStyle = createGlobalStyle`
  ${styles}
`
